import styled from "styled-components";

import {
  getBaseFont,
  hexToRgba,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";
import { Header1 as SitesparkHeader1 } from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero/header1";

export const Header1 = styled(SitesparkHeader1)`
  &::before,
  &::after {
    color: ${({
      theme: {
        colors: { yellow },
      },
    }) => hexToRgba(yellow, 0.8)};
  }
  ${getBaseFont("miller-display-roman")}
`;
